/* eslint-disable */

export enum PaymentType {
	Unknown = 0,
	Amex = 1,
	Klarna = 2,
	MasterCard = 3,
	Svea = 4,
	Swish = 5,
	Visa = 6,
	Vipps = 7,
	
}
